import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInsightsFiltersState } from "./interfaces";
import { getYearMonthForUseTaxCalculationFilter } from "utils";
import { MULTIPLE_STATE_ENTITY } from "components/upload-tax-file-modal/constants";

const yearMonth = getYearMonthForUseTaxCalculationFilter();

const initialState: IInsightsFiltersState = {
  year: yearMonth[0],
  month: yearMonth[1],
  state: MULTIPLE_STATE_ENTITY,
  entity: MULTIPLE_STATE_ENTITY,
};

export const insightsFiltersSlice = createSlice({
  name: "insightsFilters",
  initialState,
  reducers: {
    updateYear: (state, action: PayloadAction<number>) => {
      state.year = action.payload;
    },
    updateMonth: (state, action: PayloadAction<string>) => {
      state.month = action.payload;
    },
    updateState: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    updateEntity: (state, action: PayloadAction<string>) => {
      state.entity = action.payload;
    },
  },
});

export const { updateYear, updateMonth, updateState, updateEntity } =
  insightsFiltersSlice.actions;

export default insightsFiltersSlice.reducer;
